import { UPSELL_LINKS } from './site'

export interface Upsell {
  name: string
  kicker: string
  body: string
  highlights: string[]
  image: string
  href: string
}

export const upsells: Upsell[] = [
  {
    name: 'Botanical Resin Decor',
    kicker: 'Level 2 · Depth and shine',
    body: 'Learn how to set real flowers in resin with a clean, professional finish — perfect for jewelry, keychains, suncatchers and decor pieces that look boutique-worthy and sell beautifully.',
    highlights: ['Jewelry & keychains', 'Suncatchers & decor', 'Professional finish'],
    image:
      'https://cdn.magicpatterns.com/uploads/uKHRar3Ds2pvri8xx5nT7o/BOTANICAL_RESIN_DECOR.png',
    href: UPSELL_LINKS.resina,
  },
  {
    name: 'Botanical Floral Embroidery',
    kicker: 'Level 2 · Texture and detail',
    body: 'Learn how to bring real flowers into delicate embroidery designs to create hoop art, meaningful gifts and handmade pieces that are ready to give or sell.',
    highlights: ['Embroidery hoop art', 'Meaningful gifts', 'Signature pieces'],
    image:
      'https://cdn.magicpatterns.com/uploads/jkD2HboUpc6hZ88fDWmjQ4/BOTANICAL_EMBROIDERY.png',
    href: UPSELL_LINKS.bordado,
  },
]
